module.exports = __webpack_public_path__ + "img/flouci2.33b3a1d4.png";